import React from 'react';
import styles from "./login.module.scss";
import {Button, Form, Input, message as messageAnt} from 'antd';
import {useDispatch} from "react-redux";
import {useHttp} from "../../hooks/http.hook";
import {useAuth} from "../../hooks/auth.hook";
import {auth} from "../../store/redusers/authSlice";
import {useTranslation} from 'react-i18next';
import {Languages} from "../../shared/types";

const Login = () => {

  const {t, i18n} = useTranslation();
  const lang = i18n.language as Languages

  const dispatch = useDispatch()

  const {loading, request, error, clearError} = useHttp()
  const {login, logout} = useAuth()

  //Авторизация пользователя на сервере и локальное сохранение результата авторизации
  const onFinish = async (values: any) => {
    try {
      const data = await request('/api/auth/login', 'POST', {...values})
      login(data.token, data.userId)
      dispatch(auth({userId: data.userId, token: data.token}))
      let message = ''
      if (lang === 'ru') {
        message = 'Успешная авторизация'
      } else {
        message = 'Successful authorization'
      }
      messageAnt.info(message)
    } catch (e) {
      // let message = e instanceof Error ? e.message : 'Что-то пошло не так'
      logout()
      dispatch(auth({userId: null, token: null}))
      let message = ''
      if (lang === 'ru') {
        message = 'Что-то пошло не так'
      } else {
        message = 'Something went wrong.'
      }
      messageAnt.info(message)
      clearError()
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.titleWrap}>
          {/*//@ts-ignore*/}
          <p className={styles.title}>{t('LoginTitle')}</p>
        </div>
        <div className={styles.form}>
          <Form name="registration" labelCol={{span: 8,}} initialValues={{remember: true,}}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off">
            <Form.Item
              /*//@ts-ignore*/
              label={t('LoginEmail')}
              name="email"
              rules={[{
                required: true,
                /*//@ts-ignore*/
                message: t('LoginEmailTip'),
              },]}
            >
              <Input/>
            </Form.Item>
            <Form.Item
              /*//@ts-ignore*/
              label={t('LoginPassword')}
              name="password"
              rules={[{
                required: true,
                /*//@ts-ignore*/
                message: t('LoginPasswordTip'),
              },]}
            >
              <Input.Password/>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" style={{marginTop: 15}} disabled={loading}>
                {/*//@ts-ignore*/}
                {t('LoginButton')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;